import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpParams,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class BnAproveContactRequestInterceptor implements HttpInterceptor {
  constructor() {}

  shouldBeIntercepted(url: string, method: string) {
    let regex =
      /\/api\/contact-manager\/client-api\/v2\/approvals\/([0-9a-zA-Z]+-[0-9a-zA-Z]+-[0-9a-zA-Z]+-[0-9a-zA-Z]+-[0-9a-zA-Z]+)\/approvalRecords/i;
    return regex.test(url) && method === 'POST';
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(this.requestHandler(request));
  }

  requestHandler(request: HttpRequest<any>): HttpRequest<any> {
    if (this.shouldBeIntercepted(request.url, request.method)) {
      console.log("-")
      return request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
        },
      });
    }

    return request;
  }
}
